var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-modal",class:{show: _vm.show},on:{"click":function($event){_vm.$attrs.closable==null||_vm.close()}}},[_c('transition',{attrs:{"name":"v-modal-body"}},[(_vm.show)?_c('div',{staticClass:"v-modal-body",style:(_vm.style),on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default")],2):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9b89222","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue-ext/components/modal/index.vue
// module id = null
// module chunks = 